import { RootState } from "../reducers";

export const errorsSelector = ({ errors }: RootState) => errors;

export * from "./user";
